import { render, staticRenderFns } from "./Episode3.vue?vue&type=template&id=1ba2583c&"
import script from "./Episode3.vue?vue&type=script&lang=js&"
export * from "./Episode3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports